module.exports = __webpack_public_path__ + "gq.3c96f718.svg";